/**
 * PERSON I ÅRGANGEN: KATEGORIEN OG KILDENE (B1, sak 253.2, migrering 0916).
 *
 * Kategorien erstatter både «Kilde» på Personer og «Type» på Akkreditering: ett ord for «hva slags
 * folk er dette», på raden, og det kan endres. Forslaget kommer fra kilden raden ble laget av.
 *
 * Kildene er merkelapper på raden (`participation_sources.kind`) — hvorfor personen står der. De slås
 * ikke sammen ved lesing; de er der fordi en trigger eller en hånd la dem der.
 *
 * Egen fil fordi både `participations.ts` og `accreditations.ts` bruker ordene, og den første
 * importerer allerede den andre.
 */
import { z } from 'zod';

/* 1095: `supplier` er leverandøren og de ansatte (persontypene §3.2). */
export const PARTICIPATION_CATEGORIES = [
  'staff',
  'volunteer',
  'artist',
  'guest',
  'press',
  'supplier',
] as const;
export const participationCategorySchema = z.enum(PARTICIPATION_CATEGORIES);
export type ParticipationCategory = (typeof PARTICIPATION_CATEGORIES)[number];

export const PARTICIPATION_SOURCE_KINDS = [
  'member',
  'staff',
  'volunteer',
  'travel_party',
  'management',
  'organiser_person',
  'manual',
  /* 0917: en vakt i årgangen (239.19). Gir kort på Akkreditering, vises ikke som kilde. */
  'shift',
  /* 1096: kontaktpersonen og de ansatte hos en godkjent leverandør. */
  'supplier',
] as const;
export const participationSourceKindSchema = z.enum(PARTICIPATION_SOURCE_KINDS);
export type ParticipationSourceKind = (typeof PARTICIPATION_SOURCE_KINDS)[number];

/**
 * KATEGORIENE ET SØK TREFFER, som en kommaliste i spørrestrengen.
 *
 * Kategorien er et ord på skjermen («Frivillig»), og bare klienten vet hva ordet heter på brukerens
 * språk. Klienten sender derfor kategoriene søketeksten treffer, og serveren tar dem med i det
 * samme søket som navn, telefon, rolle og avdeling (punkt 53). Ingen norske ord i SQL.
 */
export const categoryListParamSchema = z
  .string()
  .trim()
  .max(80)
  .transform((value) => value.split(',').filter((one) => one !== ''))
  .pipe(z.array(participationCategorySchema).max(PARTICIPATION_CATEGORIES.length));
